import Vue from 'vue'

const bus = new Vue() // Common bus for passing events around

export default bus
